export const Button = ({className, children , onClick, disabled=false ,style}) => {
    return(
        <button style={style} onClick={onClick} className={className} disabled={disabled}>{children}</button>
    )
}